export default "https://assets.egbcdn.net/assets/packs/_/images/app/manual/manual6-ea88ab9e8c16bf0fbab4d3e98aa74df5.png";